import React, { useEffect, useState } from 'react'
import { FaMoneyBillWave } from 'react-icons/fa'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import { formatPipe, getDenomination } from '../../utils/utils'

const Rates = () => {
  const rates = useSelector((state: RootState) => state?.rates?.rates)

  const [transformCurrency] = useState({
    '1': 'USD',
    '3': 'EUR',
    '4': 'COP'
  })

  return (
    <div style={{ width: 120 }}>
      <div className="flex flex-row mb-2 text-black items-center">

        {/* <div className='flex justify-center items-center mr-2' style={{height: 22, width: 22, backgroundColor: "#0033A0", borderRadius: 20}}>
          <FaMoneyBillWave className='text-white'/>
        </div> */}

        <strong>Tasas</strong>
      </div>

      <div>
        {rates.map((rate) => {
          const decimals = (rate.id === "1" || rate.id === "3") ? 2 : 4
          const formattedRate = parseFloat(rate.rate).toFixed(decimals).replace('.', ',')
          return (
            <div className="mb-1 text-black">
              <strong>{transformCurrency[rate.id]}: </strong><strong style={{color: "#209F35"}}>Bs. {formatPipe(formattedRate, false, decimals)}</strong>
              {/* <strong>{`Bs - ${getDenomination(rate.id)}`}</strong> : <strong style={{color: "#209F35"}}>{formatPipe(rate.rate, false, (rate.id === "1" || rate.id === "3") ? 2 : 4)}</strong> */}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Rates
